module.exports = __webpack_public_path__ + "img/Frame_ItemFrame01_Color_Yellow.ac3f3ebc.png";